/*eslint no-magic-numbers: ["error", { "ignore": [0, 1, 8, 10, 20, 150] }]*/

export const getStickyTableColumnsLength = (headerTitle, rows, defaultWidth = 150, capsName = false) => {
  const pxPerLength = capsName ? 10 : 8
  const extraPx = capsName ? 20 : 10
  const result = rows.map((item) => {
    if(!item[headerTitle]){
      return 1
    }
    return item[headerTitle].toString().length
  }).sort((a, b) => {
    return b-a
  })

  return result.length ? result[0] * pxPerLength + extraPx > defaultWidth ? result[0] * pxPerLength + extraPx : defaultWidth : defaultWidth
}
